const WA_URL =
  "https://wa.me/19726661122?text=Hi%20Tripsyfy%2C%20I%20would%20like%20help%20planning%20a%20trip.%20My%20travel%20details%20are%3A";

export function WhatsAppCTA({ variant = "button", className = "" }) {
  if (variant === "banner") {
    return (
      <div
        className={`rounded-xl p-5 flex flex-col sm:flex-row items-center justify-between gap-4 ${className}`}
        style={{ backgroundColor: "#25d366" }}
      >
        <div>
          <p className="font-bold text-base text-white">Chat with us on WhatsApp</p>
          <p className="text-sm text-white/80">
            Message our travel experts and get a response within minutes.
          </p>
        </div>
        <a
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-white font-semibold px-5 py-2.5 rounded-lg text-sm hover:bg-green-50 transition-colors whitespace-nowrap"
          style={{ color: "#128c54" }}
        >
          <i className="fab fa-whatsapp text-lg" aria-hidden="true" />
          Message Us on WhatsApp
        </a>
      </div>
    );
  }

  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-2 text-white font-semibold px-5 py-2.5 rounded-lg text-sm transition-colors ${className}`}
      style={{ backgroundColor: "#25d366" }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#1ebe5d")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#25d366")}
    >
      <i className="fab fa-whatsapp text-lg" aria-hidden="true" />
      WhatsApp Us
    </a>
  );
}
